<div class="compliance-task-container" [style.min-width.px]="minWidth">
  @if(!isComplianceTasks && !isAssignedAssets) {
    <div class="d-flex w-full justify-content-between search-and-filters-container">
      <div>
        <app-search [placeholder]= "isComplianceLibrary ? ('compliance.shared.tasksTable.searchCompliance' | transloco) : ('compliance.shared.tasksTable.searchAssetOrCompliance' | transloco)" (searchTermUpdated)="onSearchTermUpdated($event)"
          [searchTerm]="searchTerm" [customWidth]="'360px'">
        </app-search>
      </div>
      @if(isComplianceLibrary) {
        <app-compliance-filters [isComplianceTasks]="true"></app-compliance-filters>
      } @else {
        <div class="d-flex">
          <span ngbDropdown class="asset-status-filter" [autoClose]="true" container="body">
            <button type="button" class="btn form-control" ngbDropdownToggle>
              <div class="d-flex flex-row justify-content-between">
                <span>{{ complianceStatusLabel }}</span>
                <i class="ph ph-caret-down lh-base"></i>
              </div>
            </button>
            <div ngbDropdownMenu  class="drop-down">
              <div class="d-flex flex-column">
                <button class="btn btn-outline" (click)="onComplianceStatusFilter(complianceStatus.All)" ngbDropdownItem>{{ 'compliance.shared.tasksTable.statusFilter.all' | transloco }}</button>
                <button class="btn btn-outline" (click)="onComplianceStatusFilter(complianceStatus.Pending)" ngbDropdownItem>{{ 'compliance.shared.tasksTable.statusFilter.pending' | transloco }}</button>
                <button class="btn btn-outline" (click)="onComplianceStatusFilter(complianceStatus.InProgress)" ngbDropdownItem>{{ 'compliance.shared.tasksTable.statusFilter.inProgress' | transloco }}</button>
                <button class="btn btn-outline" (click)="onComplianceStatusFilter(complianceStatus.Completed)" ngbDropdownItem>{{ 'compliance.shared.tasksTable.statusFilter.completed' | transloco }}</button>
                <button class="btn btn-outline" (click)="onComplianceStatusFilter(complianceStatus.Overdue)" ngbDropdownItem>{{ 'compliance.shared.tasksTable.statusFilter.overdue' | transloco }}</button>
                <button class="btn btn-outline" (click)="onComplianceStatusFilter(complianceStatus.Missed)" ngbDropdownItem>{{ 'compliance.shared.tasksTable.statusFilter.missed' | transloco }}</button>
              </div>
            </div>
          </span>
        </div>
      }
    </div>
  }

  <div #tableContainer class="table-container">
    <div class="header">
      <div class="row">
        @for(col of columns; track col.value) {
          <div [class]="col.width" [class.justify-content-center]="col.centered">
            {{ col.header }}
          </div>
        }
      </div>
    </div>

    <div class="body" [class.body--refreshing]="isRefreshing">
      @if(!isLoading && hasError) {
        <div class="state-container" [ngClass]="{ 'state-container--no-filters': isComplianceTasks }">
          <app-error-state></app-error-state>
        </div>
      } @else if(!isLoading && data.length === 0) {
        <div class="empty-state-container" [ngClass]="{ 'empty-state-container--no-filters': isComplianceTasks }">
          <app-empty-state></app-empty-state>
        </div>
      } @else if(!isLoading && expandable) {
        <div #expandableViewport class="viewport viewport--expandable"
          [ngClass]="{ 'viewport--no-filters': isComplianceTasks }"
          (scroll)="onExpandableScroll($event)">
          @for(item of data; track getRowId(item); let i = $index) {
            <div class="row" [attr.data-row-index]="i"
              [class.clickable]="rowsClickable"
              [class.row--expanded]="isExpanded(item)"
              (click)="rowsClickable && onRowClick(item)">
              <ng-container *ngTemplateOutlet="cells; context: { $implicit: item, cols: columns }"></ng-container>
            </div>

            @if(isExpanded(item)) {
              <div class="sub-table">
                <div class="row sub-table__header">
                  @for(col of subColumns; track col.value) {
                    <div [class]="col.width" [class.justify-content-center]="col.centered">
                      {{ col.header }}
                    </div>
                  }
                </div>
                @for(subRow of getSubRows(item); track $index) {
                  <div class="row sub-table__row">
                    <ng-container *ngTemplateOutlet="cells; context: { $implicit: subRow, cols: subColumns, parent: item }"></ng-container>
                  </div>
                } @empty {
                  <div class="sub-table__empty">{{ subRowsEmptyMessage }}</div>
                }
              </div>
            }
          }
          @if(isLoadingMore) {
            <div class="loading-more">
              <span class="spinner-border"></span>
            </div>
          }
        </div>
      } @else if(!isLoading) {
        <cdk-virtual-scroll-viewport itemSize="63" minBufferPx="315" maxBufferPx="630"
          class="viewport" [ngClass]="{ 'viewport--no-filters': isComplianceTasks }"
          (scroll)="closeDropdowns()"
          (scrolledIndexChange)="onScrollIndexChange($event)">
          <div *cdkVirtualFor="let item of data; let i = index;" class="row" [class.clickable]="rowsClickable" (click)="rowsClickable && onRowClick(item)">
            <ng-container *ngTemplateOutlet="cells; context: { $implicit: item, cols: columns }"></ng-container>
          </div>
          @if(isLoadingMore) {
            <div class="loading-more">
              <span class="spinner-border"></span>
            </div>
          }
        </cdk-virtual-scroll-viewport>
      } @else {
        <div class="d-flex flex-column justify-content-center align-items-center w-100 loading-container"
          [ngClass]="{ 'loading-container--no-filters': isComplianceTasks }">
          <span class="spinner-border"></span>
        </div>
      }
    </div>
  </div>
</div>

<ng-template #cells let-item let-cols="cols" let-parent="parent">
  @for(col of cols; track col.value) {
    @if(col.type === 'nullable-text') {
      <div [class]="col.width"
           [class.cell--truncate]="col.truncate"
           [class.justify-content-center]="col.centered"
           [attr.title]="getTitleValue(item, col)">
        @if(col.bold) {
          <strong>{{ getDisplayValue(item, col.value) }}</strong>
        } @else {
          <span [class.cell--muted]="isMutedValue(item, col)">{{ getDisplayValue(item, col.value) }}</span>
        }
      </div>
    } @else if(col.type === 'date') {
      <div [class]="col.width"
           [class.cell--truncate]="col.truncate"
           [class.justify-content-center]="col.centered"
           [attr.title]="getTitleValue(item, col)">
        <span>{{ hasDisplayValue(item, col.value) ? (getValue(item, col.value) | date: 'dd/MM/yyyy HH:mm') : '-' }}</span>
      </div>
    } @else if(col.type === 'status') {
      <div [class]="col.width">
        <span class="status" [ngClass]="getStatusClass(item, col.value)">
          @if(getStatusClass(item, col.value) === 'in-progress' || getStatusClass(item, col.value) === 'expiring-soon') {
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path d="M6.66667 0C2.99067 0 0 2.99067 0 6.66667C0 10.3427 2.99067 13.3333 6.66667 13.3333C10.3427 13.3333 13.3333 10.3427 13.3333 6.66667C13.3333 2.99067 10.3427 0 6.66667 0ZM8.862 9.80467L6 6.94267V2.66667H7.33333V6.39067L9.80467 8.862L8.862 9.80467Z" fill="#F4BC2B"/>
            </svg>
          } @else if(getStatusClass(item, col.value) === 'completed' || getStatusClass(item, col.value) === 'pass' || getStatusClass(item, col.value) === 'compliant') {
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    	        <path d="M7.9987 1.33594C4.3227 1.33594 1.33203 4.3266 1.33203 8.0026C1.33203 11.6786 4.3227 14.6693 7.9987 14.6693C11.6747 14.6693 14.6654 11.6786 14.6654 8.0026C14.6654 4.3266 11.6747 1.33594 7.9987 1.33594ZM6.66603 10.9446L4.1907 8.4746L5.13203 7.5306L6.6647 9.0606L10.194 5.53127L11.1367 6.47394L6.66603 10.9446Z" fill="#50AD41"/>
  	        </svg>
          } @else if(getStatusClass(item, col.value) === 'overdue' || getStatusClass(item, col.value) === 'fail' || getStatusClass(item, col.value) === 'non-compliant') {
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path d="M6.63533 0C2.97667 0 0 2.99067 0 6.66667C0 10.3427 2.99067 13.3333 6.66667 13.3333C10.3427 13.3333 13.3333 10.3427 13.3333 6.66667C13.3333 2.99067 10.3287 0 6.63533 0ZM7.33333 10H6V8.66667H7.33333V10ZM7.33333 7.33333H6V3.33333H7.33333V7.33333Z" fill="#FF7F00"/>
            </svg>
          } @else if(getStatusClass(item, col.value) === 'pending') {
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path d="M6.66667 0C2.99067 0 0 2.99067 0 6.66667C0 10.3427 2.99067 13.3333 6.66667 13.3333C10.3427 13.3333 13.3333 10.3427 13.3333 6.66667C13.3333 2.99067 10.3427 0 6.66667 0ZM8.862 9.80467L6 6.94267V2.66667H7.33333V6.39067L9.80467 8.862L8.862 9.80467Z" fill="#3873C9"/>
            </svg>
          } @else if(getStatusClass(item, col.value) === 'missed'){
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M7.96834 1.33398C4.30967 1.33398 1.33301 4.32465 1.33301 8.00065C1.33301 11.6767 4.32367 14.6673 7.99967 14.6673C11.6757 14.6673 14.6663 11.6767 14.6663 8.00065C14.6663 4.32465 11.6617 1.33398 7.96834 1.33398ZM8.66634 11.334H7.33301V10.0007H8.66634V11.334ZM8.66634 8.66732H7.33301V4.66732H8.66634V8.66732Z" fill="#FF7F00"/>
            </svg>
          }
          {{ getStatusValue(item, col.value) }}
        </span>
      </div>
    } @else if(col.type === 'expand') {
      <div [class]="col.width">
        <button type="button" class="action-btn"
          [attr.aria-expanded]="isExpanded(item)"
          [attr.aria-label]="isExpanded(item) ? ('compliance.shared.tasksTable.collapseRoutineDetails' | transloco) : ('compliance.shared.tasksTable.expandRoutineDetails' | transloco)"
          (click)="toggleExpanded(item); $event.stopPropagation()">
          <i class="ph" [class.ph-caret-down]="!isExpanded(item)" [class.ph-caret-up]="isExpanded(item)"></i>
        </button>
      </div>
    } @else if(col.type === 'sub-action') {
      <div [class]="col.width">
        <div ngbDropdown container="body" placement="bottom-end top-end" [popperOptions]="getDropdownPopperOptions" class="action-dropdown" (click)="$event.stopPropagation()">
          <button class="action-dropdown__btn" ngbDropdownToggle>
            <i class="ph ph-dots-three-vertical"></i>
          </button>
          <div ngbDropdownMenu class="action-dropdown__menu">
            @for(entry of getSubRowActions(item); track entry.action) {
              <button ngbDropdownItem
                [class.action-dropdown__danger]="entry.danger"
                (click)="onActionClick($event, parent, entry.action)">{{ entry.label }}</button>
            }
          </div>
        </div>
      </div>
    } @else if(col.type === 'action') {
      <div [class]="col.width">
        @if(isChecklistRequirements) {
          @if(isArchivedBtn) {
            <button class="action-btn" (click)="onActionClick($event, item, tableAction.Restore)">
              <i class="ph ph-arrow-counter-clockwise"></i>
            </button>
          } @else {
            <button class="action-btn" (click)="onActionClick($event, item, tableAction.Archive)">
              <i class="ph ph-archive"></i>
            </button>
          }
        } @else if(isArchivedBtn) {
          <button class="action-btn" (click)="onActionClick($event, item, tableAction.Restore)">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path d="M7 9.33594C7.97475 9.33594 8.75 8.55952 8.75 7.58594C8.75 6.61235 7.97475 5.83594 7 5.83594C6.02525 5.83594 5.25 6.61235 5.25 7.58594C5.25 8.55952 6.02525 9.33594 7 9.33594Z" fill="#9FA1A4"/>
              <path d="M12.1432 6.52256C12.0732 6.18248 11.97 5.85115 11.837 5.5379C11.7057 5.22756 11.543 4.92773 11.3528 4.64481C11.1638 4.3654 10.9486 4.10465 10.7123 3.86956C10.4767 3.63273 10.2147 3.4169 9.93533 3.22731C9.65358 3.03715 9.35317 2.87498 9.044 2.74373C8.73017 2.61015 8.39883 2.50748 8.05758 2.4369C7.70758 2.36515 7.3465 2.33073 6.98542 2.3319V1.16406L4.66667 2.91406L6.98542 4.66406V3.49856C7.26775 3.4974 7.55008 3.52423 7.8225 3.58023C8.08733 3.63506 8.34517 3.71498 8.589 3.81881C8.82992 3.92031 9.06325 4.04748 9.282 4.19448C9.49958 4.34148 9.70317 4.50948 9.8875 4.6944C10.0712 4.87756 10.2398 5.08115 10.3857 5.29815C10.5338 5.51748 10.6604 5.75081 10.7625 5.9929C10.8663 6.23615 10.9457 6.49398 11.0005 6.75765C11.0553 7.0254 11.0833 7.30248 11.0833 7.58073C11.0833 7.85898 11.0553 8.13606 11.0005 8.40323C10.9457 8.66806 10.8663 8.9259 10.7625 9.17031C10.6604 9.41123 10.5338 9.64456 10.3868 9.86331C10.2392 10.0809 10.0707 10.2845 9.88633 10.4694C9.70258 10.6537 9.49958 10.8211 9.282 10.9676C9.065 11.114 8.83225 11.2406 8.58842 11.3438C8.34517 11.4471 8.08792 11.527 7.82367 11.5818C7.287 11.6915 6.71183 11.6915 6.1775 11.5818C5.91267 11.527 5.65483 11.4471 5.411 11.3432C5.16833 11.2406 4.93558 11.114 4.71742 10.967C4.501 10.8211 4.298 10.6531 4.11367 10.4688C3.92992 10.2845 3.76133 10.0809 3.61492 9.86448C3.46675 9.64515 3.34017 9.41181 3.23808 9.17031C3.13425 8.92648 3.05492 8.66865 3.00008 8.40498C2.94467 8.13606 2.91667 7.85898 2.91667 7.58073H1.75C1.75 7.93715 1.78617 8.29298 1.85675 8.6389C1.92675 8.9784 2.03 9.30973 2.163 9.62415C2.29425 9.93448 2.457 10.2343 2.64775 10.5172C2.83617 10.7955 3.05142 11.0562 3.28767 11.2925C3.5245 11.5299 3.78583 11.7457 4.06408 11.9336C4.3435 12.1231 4.64392 12.2859 4.956 12.4177C5.26983 12.5513 5.60117 12.654 5.94242 12.7246C6.28775 12.7946 6.64358 12.8307 7 12.8307C7.35642 12.8307 7.71225 12.7946 8.05817 12.724C8.39825 12.6534 8.72958 12.5507 9.04283 12.4177C9.35608 12.2853 9.6565 12.1226 9.93533 11.9336C10.2142 11.7457 10.4755 11.5299 10.7118 11.2925C10.948 11.0562 11.1632 10.7949 11.3534 10.5155C11.543 10.2337 11.7057 9.93331 11.837 9.62415C11.9706 9.30915 12.0732 8.97781 12.1432 8.63715C12.2138 8.29298 12.25 7.93715 12.25 7.58073C12.25 7.22431 12.2138 6.86848 12.1432 6.52256Z" fill="#9FA1A4"/>
            </svg>
          </button>
        } @else if(isRequirementAssetList) {
          @if(getRowActions(item).length > 0) {
            <div ngbDropdown container="body" placement="bottom-end top-end" [popperOptions]="getDropdownPopperOptions" class="action-dropdown" (click)="$event.stopPropagation()">
              <button class="action-dropdown__btn" ngbDropdownToggle>
                <i class="ph ph-dots-three-vertical"></i>
              </button>
              <div ngbDropdownMenu class="action-dropdown__menu">
                @for(entry of getRowActions(item); track entry.action) {
                  <button ngbDropdownItem
                    [class.action-dropdown__danger]="entry.danger"
                    (click)="onDocumentActionClick($event, item, entry.action)">{{ entry.label }}</button>
                }
              </div>
            </div>
          }
        } @else if(isComplianceLibrary) {
          <div ngbDropdown container="body" placement="bottom-end top-end" [popperOptions]="getDropdownPopperOptions" class="action-dropdown" (click)="$event.stopPropagation()">
            <button class="action-dropdown__btn" ngbDropdownToggle>
              <i class="ph ph-dots-three-vertical"></i>
            </button>
            <div ngbDropdownMenu class="action-dropdown__menu">
              <button ngbDropdownItem (click)="onActionClick($event, item, tableAction.Assign)">{{ 'compliance.shared.tasksTable.actions.assignAssets' | transloco }}</button>
              <button ngbDropdownItem class="action-dropdown__danger" (click)="onActionClick($event, item, tableAction.Archive)">{{ 'compliance.shared.tasksTable.actions.archive' | transloco }}</button>
            </div>
          </div>
        } @else if(isAssignedAssets) {
          <div ngbDropdown container="body" placement="bottom-end top-end" [popperOptions]="getDropdownPopperOptions" class="action-dropdown" (click)="$event.stopPropagation()">
            <button class="action-dropdown__btn" ngbDropdownToggle>
              <i class="ph ph-dots-three-vertical"></i>
            </button>
            <div ngbDropdownMenu class="action-dropdown__menu">
              <button ngbDropdownItem (click)="onActionClick($event, item, tableAction.History)">{{ 'compliance.shared.tasksTable.actions.history' | transloco }}</button>
              <button ngbDropdownItem (click)="onActionClick($event, item, tableAction.EditRequirements)">{{ 'compliance.shared.tasksTable.actions.editRequirements' | transloco }}</button>
              @if(taskType !== 'routine') {
                <button ngbDropdownItem (click)="onActionClick($event, item, tableAction.EditFrequency)">{{ 'compliance.shared.tasksTable.actions.editFrequency' | transloco }}</button>
              }
              <button ngbDropdownItem class="action-dropdown__danger" (click)="onActionClick($event, item, tableAction.Delete)">{{ 'compliance.shared.tasksTable.actions.delete' | transloco }}</button>
            </div>
          </div>
        } @else if(isAssetHistory) {
          <button class="action-btn" (click)="actionClicked.emit(item); $event.stopPropagation()">
            <i class="ph ph-export"></i>
          </button>
        } @else if(taskType === 'periodic') {
          <div ngbDropdown container="body" placement="bottom-end top-end" [popperOptions]="getDropdownPopperOptions" class="action-dropdown" (click)="$event.stopPropagation()">
            <button class="action-dropdown__btn" ngbDropdownToggle>
              <i class="ph ph-dots-three-vertical"></i>
            </button>
            <div ngbDropdownMenu class="action-dropdown__menu">
              @if(!isComplete(item, 'complianceStatus')) {
                <button ngbDropdownItem (click)="onActionClick($event, item, tableAction.Edit)">{{ 'compliance.shared.tasksTable.actions.edit' | transloco }}</button>
                <button ngbDropdownItem (click)="onActionClick($event, item, tableAction.Reschedule)">{{ 'compliance.shared.tasksTable.actions.reschedule' | transloco }}</button>
              }
              <button ngbDropdownItem class="action-dropdown__danger" (click)="onActionClick($event, item, tableAction.Delete)">{{ 'compliance.shared.tasksTable.actions.delete' | transloco }}</button>
            </div>
          </div>
        } @else if(taskType === 'routine') {
          <div ngbDropdown container="body" placement="bottom-end top-end" [popperOptions]="getDropdownPopperOptions" class="action-dropdown" (click)="$event.stopPropagation()">
            <button class="action-dropdown__btn" ngbDropdownToggle>
              <i class="ph ph-dots-three-vertical"></i>
            </button>
            <div ngbDropdownMenu class="action-dropdown__menu">
              @if(!isRoutineComplete(item)) {
                <button ngbDropdownItem (click)="onActionClick($event, item, tableAction.AssignWorkshop)">{{ 'compliance.shared.tasksTable.actions.assignWorkshop' | transloco }}</button>
                @if (canReschedulePre(item)) {
                  <button ngbDropdownItem (click)="onActionClick($event, item, tableAction.ReschedulePre)">{{ preRescheduleLabel(item) }}</button>
                }
                @if (canReschedulePost(item)) {
                  <button ngbDropdownItem (click)="onActionClick($event, item, tableAction.ReschedulePost)">{{ postRescheduleLabel(item) }}</button>
                }
              }
              <button ngbDropdownItem class="action-dropdown__danger" (click)="onActionClick($event, item, tableAction.Delete)">{{ 'compliance.shared.tasksTable.actions.delete' | transloco }}</button>
            </div>
          </div>
        }
		  </div>
    } @else if(col.type === 'checkbox') {
      <div [class]="col.width" class="checkbox-wrapper">
        <input
          type="checkbox"
          [checked]="getValue(item, col.value)"
          (click)="$event.stopPropagation()"
          (change)="onCheckboxChange($event, item, col.value)"
          class="custom-checkbox"/>
      </div>
    } @else if(col.type === 'stacked') {
      <div [class]="col.width" class="flex-column align-items-start gap-1">
        <span class="stacked-primary">{{ getDisplayValue(item, col.value) }}</span>
        <!-- With no primary value the cell is a plain '-'; a second '-' underneath reads as missing data twice. -->
        @if(hasDisplayValue(item, col.value)) {
          <span class="stacked-secondary">{{ getDisplayValue(item, col.secondaryValue!) }}</span>
        }
      </div>
    } @else if(col.type === 'link') {
      <div [class]="col.width">
        @if(hasLinkValue(item, col)) {
          <button type="button" class="cell-link" [attr.title]="getDisplayValue(item, col.value)" (click)="onLinkClick($event, item, col)">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path d="M14 2H6C4.897 2 4 2.897 4 4V20C4 21.103 4.897 22 6 22H18C19.103 22 20 21.103 20 20V8L14 2ZM14 4.414L17.586 8H14V4.414ZM6 20V4H12V10H18L18.001 20H6Z" fill="#9FA1A4"/>
            </svg>
            <span class="cell-link__text">
              <span class="cell-link__primary">{{ getDisplayValue(item, col.value) }}</span>
              @if(col.subLabelValue && hasDisplayValue(item, col.subLabelValue)) {
                <span class="cell-link__secondary">{{ getDisplayValue(item, col.subLabelValue) }}</span>
              }
            </span>
          </button>
        } @else {
          <span class="cell--muted">{{ col.mutedValue ?? '-' }}</span>
        }
      </div>
    } @else {
      <div [class]="col.width"
           [class.cell--truncate]="col.truncate"
           [class.justify-content-center]="col.centered"
           [attr.title]="getTitleValue(item, col)">
        @if(col.bold) {
          <strong>{{ getDisplayValue(item, col.value) }}</strong>
        } @else {
          <span [class.cell--muted]="isMutedValue(item, col)">{{ getDisplayValue(item, col.value) }}</span>
        }
      </div>
    }
  }
</ng-template>
